export const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL || 'media.stubcloudstatic.com';
export const CLOUDINARY_CATALOG_NAME = process.env.REACT_APP_CLOUDINARY_CATALOG_NAME || 'stubhub-catalog';
export const CLOUDINARY_PRODUCT_NAME = process.env.REACT_APP_CLOUDINARY_PRODUCT_NAME || 'stubhub-product';
export const CLOUDINARY_DEFAULT_LOGO_NAME = 'defaultLogo.jpg';
